import { useCallback, useEffect, useState } from 'react';
import client, { mensajeDeError } from '../../api/client';
import Button from '../../components/ui/Button';
import Modal from '../../components/ui/Modal';
import Spinner from '../../components/ui/Spinner';
import { Campo, Etiqueta, Entrada, AreaTexto, MensajeError } from '../../components/ui/Form';
import { TituloSeccion, BarraAcciones, TablaEnvoltura, Tabla, CeldaAcciones, SinDatos } from './comunes';

const vacio = { nombre: '', descripcion: '', nivel: '', duracionMinutos: 50 };

function TiposClaseAdmin() {
  const [tipos, setTipos] = useState(null);
  const [editando, setEditando] = useState(null);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(() => {
    client.get('/tipos-clase').then(({ data }) => setTipos(data)).catch(() => setTipos([]));
  }, []);

  useEffect(cargar, [cargar]);

  const abrir = (tipo) => {
    setError('');
    setEditando(
      tipo
        ? {
            id: tipo.id,
            nombre: tipo.nombre,
            descripcion: tipo.descripcion || '',
            nivel: tipo.nivel || '',
            duracionMinutos: tipo.duracion_minutos,
          }
        : { ...vacio }
    );
  };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setError('');
    try {
      if (editando.id) {
        await client.put(`/tipos-clase/${editando.id}`, editando);
      } else {
        await client.post('/tipos-clase', editando);
      }
      setEditando(null);
      cargar();
    } catch (err) {
      setError(mensajeDeError(err));
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    setError('');
    try {
      await client.delete(`/tipos-clase/${id}`);
      cargar();
    } catch (err) {
      setError(mensajeDeError(err));
    }
  };

  if (!tipos) return <Spinner />;

  const cambiar = (campo) => (e) => setEditando((d) => ({ ...d, [campo]: e.target.value }));

  return (
    <>
      <TituloSeccion>Tipos de clase</TituloSeccion>
      <BarraAcciones>
        <Button onClick={() => abrir(null)}>Nuevo tipo de clase</Button>
      </BarraAcciones>
      {error && !editando && <MensajeError role="alert">{error}</MensajeError>}
      <TablaEnvoltura>
        {tipos.length === 0 ? (
          <SinDatos>Sin tipos de clase.</SinDatos>
        ) : (
          <Tabla>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Nivel</th>
                <th>Duración</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tipos.map((t) => (
                <tr key={t.id}>
                  <td>{t.nombre}</td>
                  <td>{t.nivel || '—'}</td>
                  <td>{t.duracion_minutos} min</td>
                  <CeldaAcciones>
                    <Button $variante="secundario" $chico onClick={() => abrir(t)}>
                      Editar
                    </Button>
                    <Button $variante="peligro" $chico onClick={() => eliminar(t.id)}>
                      Eliminar
                    </Button>
                  </CeldaAcciones>
                </tr>
              ))}
            </tbody>
          </Tabla>
        )}
      </TablaEnvoltura>

      <Modal
        abierto={!!editando}
        titulo={editando?.id ? 'Editar tipo de clase' : 'Nuevo tipo de clase'}
        onCerrar={() => setEditando(null)}
      >
        {editando && (
          <form onSubmit={guardar}>
            {error && <MensajeError role="alert">{error}</MensajeError>}
            <Campo>
              <Etiqueta htmlFor="t-nombre">Nombre</Etiqueta>
              <Entrada id="t-nombre" value={editando.nombre} onChange={cambiar('nombre')} required />
            </Campo>
            <Campo>
              <Etiqueta htmlFor="t-desc">Descripción</Etiqueta>
              <AreaTexto id="t-desc" value={editando.descripcion} onChange={cambiar('descripcion')} />
            </Campo>
            <Campo>
              <Etiqueta htmlFor="t-nivel">Nivel</Etiqueta>
              <Entrada id="t-nivel" value={editando.nivel} onChange={cambiar('nivel')} placeholder="Todos los niveles" />
            </Campo>
            <Campo>
              <Etiqueta htmlFor="t-dur">Duración (minutos)</Etiqueta>
              <Entrada
                id="t-dur"
                type="number"
                min="20"
                max="120"
                value={editando.duracionMinutos}
                onChange={cambiar('duracionMinutos')}
                required
              />
            </Campo>
            <Button type="submit" $completo disabled={guardando}>
              {guardando ? 'Guardando…' : 'Guardar'}
            </Button>
          </form>
        )}
      </Modal>
    </>
  );
}

export default TiposClaseAdmin;
